import { ChevronRightIcon } from 'lucide-react'
import { useState } from 'react'

import { TableCell, TableRow } from '@/components/ui'
import { cn, humanizeDate } from '@/utils'
import type { CreditEntryGroup } from '../groupEntries'
import { amountClass, describeGroup, formatDelta, hasDetails } from '../labels'
import { ChildRow } from './ChildRow'

export const GroupedEntryRow = ({ group }: { group: CreditEntryGroup }) => {
  const [expanded, setExpanded] = useState(false)
  const expandable = hasDetails(group)
  const expiresAt = group.entries[0].expiresAt

  return (
    <>
      <TableRow
        className={cn(expandable && 'cursor-pointer')}
        onClick={expandable ? () => setExpanded((open) => !open) : undefined}
      >
        <TableCell className="w-8">
          {expandable && (
            <button
              type="button"
              aria-expanded={expanded}
              aria-label={expanded ? 'Collapse entries' : 'Expand entries'}
              className="text-muted-foreground flex cursor-pointer items-center"
            >
              <ChevronRightIcon
                className={cn(
                  'size-4 transition-transform',
                  expanded && 'rotate-90',
                )}
              />
            </button>
          )}
        </TableCell>
        <TableCell className="whitespace-nowrap">
          {humanizeDate(group.createdAt)}
        </TableCell>
        <TableCell>{describeGroup(group)}</TableCell>
        <TableCell className={amountClass(group.totalDelta)}>
          {formatDelta(group.totalDelta)}
        </TableCell>
        <TableCell className="text-muted-foreground whitespace-nowrap">
          {expiresAt ? humanizeDate(expiresAt) : '—'}
        </TableCell>
      </TableRow>
      {expanded &&
        group.entries.map((entry) => <ChildRow key={entry.id} entry={entry} />)}
    </>
  )
}
